import { cn } from "@/lib/utils";

interface MobileListLoadingProps {
  className?: string;
  label: string;
}

export const MobileListLoading = ({
  className,
  label,
}: MobileListLoadingProps) => {
  return (
    <div className={cn("flex justify-center py-8", className)}>
      <div className="flex items-center gap-2">
        <div className="h-5 w-5 animate-spin rounded-full border-2 border-gray-300 border-t-blue-600" />
        <span className="text-base text-gray-600">{label}</span>
      </div>
    </div>
  );
};
